<template>
    <account-selector v-slot="{ accounts, select, professional }">
        <div class="p-8">
            <div>
                <h3 class="mb-4 text-base text-black">{{ $t('pages.accounts.title', { professional: professional.company }) }}</h3>
                <div
                    class="p-6 bg-white shadow flex items-center hover:shadow-md cursor-pointer mb-4"
                    v-for="account in accounts"
                    :key="account.uuid"
                    @click="select(account)"
                >
                    <div
                        v-if="account.logo"
                        class="h-16 w-16 rounded bg-contain bg-center bg-no-repeat bg-gray-400 mr-4"
                        :style="{'background-image': `url(${account.logo})`}"
                    ></div>
                    <span class="text-gray-600 font-light">
                        {{ account.uuid }}
                    </span>
                    <div class="flex-1"></div>
                    <i class="fas fa-arrow-circle-right text-2xl text-gray-600"></i>
                </div>
            </div>
        </div>
    </account-selector>
</template>

<script>
import AccountSelector from "../Accounts/RenderlessSelector.vue"

export default { components: { AccountSelector } }
</script>